module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cl":{"incomesText":"Agregar Renta","debtText":"Agregar Deuda","EligibilityText":"Elegibilidad","equifaxPdfLink":"Descargar Equifax"},"pe":{"incomesText":"Agregar Renta","debtText":"Agregar Deuda"},"br":{"incomesText":"Adicionar Salário","debtText":"Adicionar Dívida"}}')
  delete Component.options._Ctor
}
